/*
 * @Author: claude.ai
 * @Date: 2025-05-20 10:00:00
 * @Last Modified by: claude.ai
 * @Last Modified time: 2025-05-20 10:00:00
 */
import { commonServerInstance } from '@/utilities/instances'

export interface IApproveTaskItemBase {
  title_info: {
    title?: string
    subtitle?: string
    [key: string]: string | number | undefined
  }
  application_info: {
    Creator?: string
    'Submission Time'?: string
    [key: string]: string | number | undefined
  }
  model_info: {
    'Partner ID'?: string
    'Partner Name'?: string
    'Rate Card ID'?: string
    'Start Date'?: string
    'End Date'?: string
    Description?: string
    [key: string]: string | number | undefined
  }
  download_info: {
    'Zone Details'?: {
      relative: string
      absolute: string
    }
    'Price Details'?: {
      relative: string
      absolute: string
    }
    [key: string]: string | number | undefined | any
  }
  related_data: []
  history: []
  metadata: []
  id: string
}
export interface IApproveTaskItemRedirect {
  redirect: boolean
  url: string
}

export type IApproveTaskItem = IApproveTaskItemBase | IApproveTaskItemRedirect

export interface IApproveTaskParams {
  target_model_type?: string
  creator?: string
  merchant_id?: string
  submission_date_start?: string
  submission_date_end?: string
  page?: number | string
  per_page?: number | string
}

export interface IApproveTaskResponse {
  instances: IApproveTaskItem[]
  total: number
}

export interface ISummaryCardItem {
  id?: string
  title: string
  count: number
  icon?: string
}

export interface ISummaryCardsResponse {
  data: ISummaryCardItem[]
}

export interface IApproveRejectPayload {
  comment: string
}

/**
 * 获取汇总卡片信息
 */
export const getSummaryCards = async (): Promise<ISummaryCardsResponse> => {
  const response = await commonServerInstance.get('/api/v1/approval/counts')
  return response?.data?.data
}

/**
 * 搜索任务列表
 * @param params 搜索参数
 */
export const searchTaskList = async (
  params: IApproveTaskParams
): Promise<IApproveTaskResponse> => {
  const response = await commonServerInstance.post('/api/v1/approval/search', {
    ...params
  })
  return response?.data?.data
}

/**
 * 获取任务详情
 * @param id 任务ID
 */
export const getTaskDetail = async (id: string): Promise<IApproveTaskItem> => {
  const response = await commonServerInstance.get(
    `/api/v1/approval/process/instances/${id}`
  )
  return response?.data?.data
}

/**
 * 执行同意操作
 * @param id 任务ID
 * @param payload 同意参数
 */
export const approveTask = async (
  id: string,
  payload: IApproveRejectPayload
): Promise<any> => {
  const response = await commonServerInstance.post(
    `/api/v1/approval/process/instances/${id}/approve`,
    payload
  )
  return response?.data?.data
}

/**
 * 执行驳回操作
 * @param id 任务ID
 * @param payload 驳回参数
 */
export const rejectTask = async (
  id: string,
  payload: IApproveRejectPayload
): Promise<any> => {
  const response = await commonServerInstance.post(
    `/api/v1/approval/process/instances/${id}/decline`,
    payload
  )
  return response?.data?.data
}

/**
 * 获取创建者列表
 */
export const getCreators = async (): Promise<any> => {
  const response = await commonServerInstance.get('/api/v1/approval/creators')
  return response?.data?.data
}

/**
 * 获取任务类型列表
 */
export const getTaskTypes = async (): Promise<any> => {
  const response = await commonServerInstance.get('/api/v1/approval/types')
  return response?.data?.data
}
